export default "__VITE_ASSET__DQ_0mSI7__"